import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Store} from "@ngxs/store";
import {Router} from "@angular/router";
import {SettingsModel} from "../../../_stores/settings/_models/settings.model";
import {SettingsState} from "../../../_stores/settings/_state/settings.state";
import {ModalOpenAction} from "../../../_stores/modal/_actions/modal.actions";
import {HttpClient} from "@angular/common/http";
import {ChangeSoundAction} from "../../../_stores/settings/_actions/settings.actions";
import {UserModel} from "../../../_stores/user/_models/user.model";
import {UserState} from "../../../_stores/user/_state/user.state";
import {CartState} from "../../../_stores/cart/_state/cart.state";
import {AuthState} from "../../../_stores/auth/_state/auth.state";
import {AuthChangeAccessWithPin} from "../../../_stores/auth/_actions/auth.actions";
import {SwitchUserToDefault} from "../../../_stores/user/_actions/user.actions";
import {environment} from "../../../../environments/environment";
import {TipsOpenAction} from "../../../_stores/tips/_actions/tips.actions";


@Component({
  selector: 'bh-header',
  templateUrl: './bh-header.component.html',
  styleUrls: ['./bh-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BhHeaderComponent implements OnInit, OnDestroy {
  @Input('type') set _type(_type: string) {
    if (_type) {
      this.interface.type = _type;
    }
  }
  protected readonly environment = environment;
  interface: {
    auth: boolean,
    type: string,
    settings: SettingsModel,
    user: UserModel,
    cart_products: any[],
    _cache: any
  } = {
    auth: false,
    type: 'default',
    settings: undefined,
    user: undefined,
    cart_products: [],
    _cache: {
      open_menu: false,
      open_user_menu: false,
      subscribe: {
        settings: undefined,
        user: undefined
      }
    }
  }

  constructor(private store: Store, private cdr: ChangeDetectorRef,private router: Router, private http: HttpClient) {}

  ngOnInit(): void {
    this.initSettings();
    this.initUser();
    this.initCart();
  }
  ngOnDestroy(): void {
    if (!this.interface._cache) {return}
    Object.keys(this.interface._cache.subscribe).forEach((_subscribe) => {
      if (this.interface._cache.subscribe[_subscribe]) {
        this.interface._cache.subscribe[_subscribe].unsubscribe();
      }
    });
  }

  initSettings(): void {
    this.interface._cache.subscribe.settings = this.store.select(SettingsState.selectSettings).subscribe((res: any)=> {
      this.interface.settings = res;
      this.interface.auth = this.store.selectSnapshot(AuthState.selectAccess);
      this.cdr.detectChanges();
    });
  }

  initUser(): void {
    this.interface._cache.subscribe.user = this.store.select(UserState.selectUser).subscribe((_user: any)=> {
      this.interface.user = _user;
      this.cdr.detectChanges();
    });
  }
  initCart(): void {
    this.interface._cache.subscribe.cart = this.store.select(CartState.selectCartProducts).subscribe((_cart) => {
      this.interface.cart_products = _cart;
      this.cdr.markForCheck();
    });
  }

  actionOpenLanguageSelect(): void {
    this.store.dispatch(new ModalOpenAction('change_language'));
  }
  actionToggleMenu(): void {
    this.interface._cache.open_menu = !this.interface._cache.open_menu;
  }
  actionToggleUserMenu(): void {
    this.interface._cache.open_user_menu = !this.interface._cache.open_user_menu;
  }
  actionToggleSound(): void {
    this.store.dispatch(new ChangeSoundAction());
  }
  actionOpenCart(): void {
    this.router.navigate(['/store/cart/']).then();
  }
  actionOpenProfile(): void {
    if(!this.interface.auth) {
      this.store.dispatch(new ModalOpenAction('login'));
      return;
    } else {
      this.router.navigate(['/profile']).then();
    }
  }
  actionSwitchAccess(): void {
    if(this.interface.user.relationship == 'child') {
      this.store.dispatch(new SwitchUserToDefault());
    }
    this.store.dispatch(new AuthChangeAccessWithPin(true));
  }

  test(): void {
    this.store.dispatch(new TipsOpenAction({type: 'done'}));
  }
}
